import { ChevronDown } from 'lucide-react';
import { useState } from 'react';

const faqs = [
  {
    question: 'How does Storyclash export influencer and campaign data to Klipfolio dashboards?',
    answer: 'Storyclash exports creator and campaign metrics to Klipfolio via a secure REST API. After authenticating with your API key, Storyclash becomes a live data source for Klipfolio dashboards without any manual data uploads.'
  },
  {
    question: 'Which Storyclash metrics can I visualize in Klipfolio?',
    answer: 'You can visualize impressions, reach, engagement rate, conversions, revenue attribution, EMV, ROI, ROAS and other Storyclash creator metrics inside Klipfolio. All metrics can be used in charts, tables, goals and KPI tiles.'
  },
  {
    question: 'How often does Storyclash sync creator data with Klipfolio?',
    answer: 'Storyclash syncs influencer performance data to Klipfolio in near real time or on scheduled intervals, depending on your dashboard refresh settings.'
  },
  {
    question: 'Do I need technical skills to connect Storyclash to Klipfolio?',
    answer: 'Yes, you need some technical skills to set up the REST API connection with your Storyclash API key. However, once connected, marketing teams can build dashboards with drag-and-drop components without additional technical expertise.'
  },
  {
    question: 'Is the Storyclash → Klipfolio integration secure and GDPR-compliant?',
    answer: 'Yes. Storyclash uses encrypted REST API endpoints and token-based authentication, and processes influencer and campaign data on GDPR-compliant EU infrastructure.'
  }
];

export default function KlipfolioFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-20 px-6" style={{ backgroundColor: '#FFFFFF' }}>
      <div className="max-w-4xl mx-auto">
        <h2 className="text-center mb-16" style={{ fontSize: '36px', lineHeight: '1', fontWeight: '600', color: '#333333', fontFamily: 'Roboto, sans-serif' }}>
          Klipfolio Integration FAQ
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="border-2 overflow-hidden" style={{ borderColor: '#E5EAEC', borderRadius: '20px' }}>
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors duration-200"
              >
                <h3 className="pr-4" style={{ fontSize: '18px', lineHeight: '1', fontWeight: '600', color: '#333333', fontFamily: 'Roboto, sans-serif' }}>
                  {faq.question}
                </h3>
                <ChevronDown
                  className={`w-5 h-5 flex-shrink-0 transition-transform duration-200 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                  style={{ color: '#19B776' }}
                />
              </button>
              {openIndex === index && (
                <div className="px-6 pb-6">
                  <p style={{ fontSize: '16px', lineHeight: '1.3', fontWeight: '400', color: '#333333', fontFamily: 'Roboto, sans-serif' }}>
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
}
